import React, {Component} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import $ from 'jquery';
import {URLS} from '../urls';

export default class AddLifeInsuranceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lifeInsurance: {
                name: '',
                description:''
            },
        };
    }

    updateLifeInsuranceName = (event) => {
        const {lifeInsurance} = this.state;
        lifeInsurance.name = event.target.value;
        this.setState({
            lifeInsurance
        });
    };
    updateLifeInsuranceDescription = (event) => {
        const {lifeInsurance} = this.state;
        lifeInsurance.description = event.target.value;
        this.setState({
            lifeInsurance
        });
    };
    
    submitLifeInsurance = (e) => {
        e.preventDefault();
        const {lifeInsurance} = this.state;
        const token = 'dummy token'; // localStorage.getItem('token');
        fetch(`${URLS.backendLifeInsurances}/add`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Token ${token}`,
            },
            body: JSON.stringify({lifeInsurance: lifeInsurance}),
        }).then(res => res.json())
            .then((result) => {
                this.props.updateLifeInsurancesList(result.lifeInsurance);
                this.props.changeShowLifeInsuranceState();
                // $('#add_lifeInsurance').hide();
            });

    };

    cancelLifeInsurance = (e) => {
        e.preventDefault();
        this.props.changeShowLifeInsuranceState();
        // $('#add_lifeInsurance').hide();
    };

    render() {
        const {lifeInsurance} = this.state;
        return (
            <div id='add_lifeInsurance' style={
                this.props.isShow ?
                    {
                        width: '50%',
                        position: 'fixed',
                        left: '50%',
                        marginLeft: '-25%',
                        top: '20px',
                        zIndex: '2000',
                        display: 'block',
                        backgroundColor: '#eaecef',
                        // height: '100%',
                        borderRadius: '10px'
                    }:{
                        width: '50%',
                        position: 'fixed',
                        left: '50%',
                        marginLeft: '-25%',
                        top: '20px',
                        zIndex: '2000',
                        display: 'none',
                        backgroundColor: '#eaecef',
                        // height: '100%',
                        borderRadius: '10px'
                    }
            }>
                <Form onSubmit={this.submitLifeInsurance} style={
                    {
                        // overflowY: 'scroll',
                        maxHeight: '100%',
                        // padding: '50px 30px',
                        borderRadius: '10px'
                    }
                }>
                    <Form.Group as={Row} style={{
                        backgroundColor: '#5378b2',
                        alignItems: 'left',
                        justifyContent: 'left',
                        fontSize: '16px',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        height:'60px',
                        borderRadius: '10px 10px 0 0',
                        padding : '10px 15px',
                        marginLeft: '0',
                        marginRight: '0',
                        display : 'block'
                    }}>
                        <span style={{display:'inline-block', height:'40px',lineHeight:'40px',float:'left'}}>Create New LifeInsurance</span>
                        <span style={{display:'inline-block', height:'40px',float:'right',padding: '2px 10px'}}>
                            <button className='btn btn-info' style={
                                {
                                    padding:'2px 10px',
                                    background: '#ffffff',
                                    color: '#000000',
                                    borderRadius: '20px',
                                    border: 'none'
                                }
                            } onClick={this.cancelLifeInsurance}>x</button>
                        </span>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            LifeInsurance
                        </Form.Label>
                        <Col sm={6}>
                            <Form.Control value={lifeInsurance.name} onChange={this.updateLifeInsuranceName}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            Description
                        </Form.Label>
                        <Col sm={6}>
                            <Form.Control value={lifeInsurance.description} onChange={this.updateLifeInsuranceDescription}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0',paddingRight: '15px', justifyContent: 'flex-end'}}>
                        <button style={{borderRadius : '7px',backgroundColor:'#5378b2', border:'none'}} className='btn btn-primary submit-btn'>Create Now</button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}